const subjectMapping = {
  AASR: "Anthro/Sociology of Religion",
  ADSP: "Applied Data Science",
  AFAM: "African/African:Amer Studies",
  AMER: "American Culture",
  ANST: "Ancient Studies",
  ANTH: "Anthropology",
  ANTM: "Anatomy",
  ARAB: "Arabic",
  ARCH: "Architectural Studies",
  ARTD: "Art/Design",
  ARTH: "Art History",
  ARTV: "Visual Arts",
  ASHM: "Arts/Sci Basic to Hum Bio/Me",
  ASLG: "American Sign Language",
  ASTR: "Astronomy/Astrophysics",
  BBLE: "Bible",
  BCHM: "Biological Chemistry",
  BCHY: "Biochemistry",
  BCMB: "Biochemistry/Molecular Biology",
  BEHV: "Behavioral Sciences",
  BIBL: "Biblical Studies",
  BIOS: "Biological Sciences (College)",
  BIOY: "Biology",
  BMSC: "Biomedical Sciences",
  BPHS: "Biophysical Sciences",
  BPSY: "Biopsychology",
  BUSN: "Business",
  CAAM: "Computational and Applied Math",
  CAPP: "Comp Analysis/Public Pol",
  CCTS: "Clinical/Translational Science",
  CEGU: "Environment/Geog/Urbanization",
  CFSC: "Conceptual Foundations of Sci",
  CHDV: "Comparative Human Development",
  CHEM: "Chemistry",
  CHSS: "Conceptual/Hist Studies of Sci",
  CHST: "Chicago Studies",
  CLAS: "Classics",
  CLCV: "Classical Civilization",
  CLNT: "Clinical Nutrition",
  CMES: "Middle Eastern Studies",
  CMLT: "Comparative Literature",
  CMSC: "Computer Science",
  CMST: "Cinema/Media Studies",
  COGC: "Cognition/Communication",
  COGS: "Cognitive Science",
  COVA: "Visual Arts",
  CPHY: "Cell Physiology",
  CPNS: "Computational Neuroscience",
  CRES: "Comp Race/Ethnic Studies",
  CRWR: "Creative Writing",
  CSLT: "Comp Studies in Literature",
  CTMI: "Clinical Trials Management",
  DATA: "Data Science",
  DEMS: "Democracy Studies",
  DIGS: "Digital Humanities",
  DVBI: "Developmental Biology",
  DVPR: "Philosophy of Religions",
  DVPS: "Developmental Psychology",
  ECEV: "Ecology/Evolution",
  ECON: "Economics",
  EDSO: "Education and Society",
  ENGL: "English Language/Literature",
  ENSC: "Environnemental Sciences",
  ENST: "Environmental/Urban Studies",
  ETHS: "Ethics/Society",
  EVOL: "Evolutionary Biology",
  FINM: "Financial Mathematics",
  FREN: "French",
  GEGY: "Geography",
  GENE: "Genetics",
  GEOG: "Geographical Sciences",
  GEOS: "Geophysical Sciences",
  GISC: "Geographic Information Science",
  GLST: "Global Studies",
  GNDR: "Gender Studies",
  GNSE: "Gender/Sexuality Studies",
  GREK: "Greek",
  GRMN: "German",
  GSHU: "Humanities General Studies",
  HCHR: "History of Christianity",
  HCUL: "History of Culture",
  HGEN: "Human Genetics",
  HIJD: "History of Judaism",
  HIPS: "History, Philosophy, and Social Sciences",
  HISL: "History of Islam",
  HIST: "History",
  HLTH: "Health and Society",
  HMRT: "Human Rights",
  HNUT: "Hum Nutrition/Nutritional Bio",
  HREL: "History of Religions",
  HSTD: "Health Studies",
  HUDV: "Human Development",
  HUMA: "Humanities",
  IMMU: "Immunology",
  INRE: "International Relations",
  INST: "International Studies",
  ISHU: "Humanities Interdisciplinary Studies",
  ISLM: "Islamic Studies",
  JAPN: "Japanese",
  JWSC: "Jewish Studies",
  LACS: "Latin American and Caribbean Studies",
  LATN: "Latin",
  LAWS: "Laws",
  LGLN: "Languages in Linguistics",
  LING: "Linguistics",
  LLSO: "Law/Letters/Society",
  LTAM: "Latin American Studies",
  MAAD: "Media Arts and Design",
  MACS: "Computational Social Science",
  MADD: "Media Arts and Design",
  MAPS: "Master of Arts Program in the Social Sciences",
  MATH: "Mathematics",
  MATS: "Mathematical Sciences",
  MBIO: "Medical Biology",
  MDVL: "Medieval Studies",
  MEDC: "Medicine",
  MENG: "Molecular Engineering",
  METH: "Methodology",
  MGCB: "Molecular Genetics/Cell Bio",
  MICR: "Microbiology",
  MOLM: "Molecular Medicine",
  MOMN: "Molecular Metabolism/Nutrition",
  MPHY: "Medical Physics",
  MSSD: "Mathematics/Social Science",
  MUSI: "Music",
  NDVS: "Non:Degree Visitor",
  NECV: "Near Eastern Civilizations",
  NEHT: "Near Eastern History",
  NOND: "Special Non:Degree",
  NSCI: "Neuroscience",
  NURB: "Neurobiology",
  NURL: "Neurology",
  ORGB: "Organismal Biology/Anatomy",
  PARR: "Parrhesia Public Discourse",
  PATH: "Pathology",
  PBPL: "Public Policy",
  PBHS: "Public Health Sciences",
  PCGC: "Cognition/Communication",
  PECO: "Political Economy",
  PERL: "Politics/Econ/Rhetoric/Law",
  PHAR: "Pharmacology/Physiological Sci",
  PHIL: "Philosophy",
  PHSC: "Physical Science",
  PHYS: "Physics",
  PLSC: "Political Science",
  PSDG: "Physical Sciences Government",
  PSYC: "Psychology",
  PPHA: "Public Policy Studies",
  QMSA: "Quantitative Social Analysis",
  RDIN: "Race, Diaspora, and Indigeneity",
  RELH: "Religion/Humanities",
  RHUS: "Religion/Human Sciences",
  RLST: "Religious Studies",
  RMET: "Rsch Methodology/Quant Psych",
  RPST: "Religion/Psychological Studies",
  SALC: "South Asian Languages and Civilizations",
  SCPD: "Science Comm/Public Discourse",
  SCTH: "Social Thought",
  SIGN: "Signature Courses",
  SMSP: "Summer Special Programs",
  SOCI: "Sociology",
  SOMD: "Social Medicine",
  SOPS: "Social/Organizational Psych",
  SOSC: "Social Sciences",
  SPAN: "Spanish",
  STAT: "Statistics",
  TAPS: "Theater/Performance Studies",
  THEO: "Theology",
  URBS: "Urban Studies",
  VIRO: "Virology",
};

export default subjectMapping;